import React from 'react';
import { clampRating, getInitials } from '../data/googleReviews';

function Stars({ rating, className = '' }) {
  const filled = clampRating(rating);
  return (
    <span className={`am-stars ${className}`} role="img" aria-label={`Rated ${filled} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <svg
          key={i}
          className={`am-star${i <= filled ? ' is-filled' : ''}`}
          viewBox="0 0 24 24"
          width="18"
          height="18"
          aria-hidden="true"
        >
          <path d="M12 2.5l2.9 6 6.6.6-5 4.3 1.5 6.5L12 17l-6 3.4 1.5-6.5-5-4.3 6.6-.6z" />
        </svg>
      ))}
    </span>
  );
}

export default function ReviewCard({ review }) {
  const { name, text, rating, photo, subtitle = 'Hired cleaning service', initials } = review || {};
  return (
    <article className="am-card am-review-card am-greview-card">
      {photo && (
        <div className="am-greview-photo">
          <img src={photo} alt={`AM Facilities cleaning result from ${name}'s review`} loading="lazy" />
        </div>
      )}
      <div className="am-greview-id">
        <span className="am-greview-avatar" aria-hidden="true">{initials || getInitials(name)}</span>
        <span className="am-greview-meta">
          <span className="am-review-name am-greview-name">{name}</span>
          <span className="am-greview-sub">{subtitle}</span>
        </span>
      </div>
      <p className="am-review-text am-greview-text">{text}</p>
      <div className="am-greview-pill">
        <Stars rating={rating} className="am-greview-pill-stars" />
        <span className="am-greview-quote" aria-hidden="true">&#8220;</span>
      </div>
    </article>
  );
}
